module.exports = __webpack_public_path__ + "img/15.afc5ca53.svg";